import React from "react";
import InfiniteCarousel from "react-leaf-carousel";
// import img1 from "assets/img/social/prod-auto.png";
// import img2 from "assets/img/social/p-hogar.png";
// import img3 from "assets/img/social/p-notificaciones.png";
// import img4 from "assets/img/social/p-viajes.png";

const SliderCotizadores = ({sliders}) => (
  <InfiniteCarousel
    breakpoints={[
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
    ]}
    dots={true}
    showSides={true}
    sidesOpacity={0.5}
    sideSize={0.1}
    slidesToScroll={1}
    slidesToShow={3}
    /*scrollOnDevice={true}*/

    //  autoCycle={false}//Habilitar y deshabilitar el carrusel
  >
      {sliders && sliders !== undefined && sliders.map(seccion => {
          // item completo o solo imagen
          let itemCompleto = false;
          let soloImagen = false;
          if(seccion.contenido.url_icono_img){
            if(seccion.contenido.url_redireccion) itemCompleto = true;
            else soloImagen = true;
          }
          return(
            <div key={seccion.titulo}>
              {itemCompleto &&
                <a 
                  href={(seccion.contenido.url_redireccion && seccion.contenido.url_redireccion !== null && seccion.contenido.url_redireccion !== "") ? seccion.contenido.url_redireccion : "#"}
                  target={"_blank"}
                >
                  <img alt='' src={seccion.contenido.url_icono_img} />
                </a>
              }
              {soloImagen &&
                <img alt='' src={seccion.contenido.url_icono_img} />
              }
            </div>
          )
        }
      )}              
  </InfiniteCarousel>
);

export default SliderCotizadores;
